import { FC } from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { Badge } from '../../ui/Badge';
import { WhatsAppStatus } from '../../../api/whatsapp';

interface IntegrationsSettingsTabProps {
  whatsappStatus: WhatsAppStatus | null;
  onRefreshWhatsApp: () => void;
  onDisconnectWhatsApp: () => void;
  onNavigateToWhatsApp?: () => void;
}

export const IntegrationsSettingsTab: FC<IntegrationsSettingsTabProps> = ({
  whatsappStatus,
  onRefreshWhatsApp,
  onDisconnectWhatsApp,
  onNavigateToWhatsApp,
}) => {
  const isConnected = whatsappStatus?.connected === true;

  return (
    <div className="space-y-6">
      {/* WhatsApp Integration Card */}
      <Card id="whatsapp-settings">
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Linha do WhatsApp
              </h3>
              <p className="text-xs text-content-muted">
                Sessão ativa para envio automático e sincronização de grupos
              </p>
            </div>
          }
          action={
            <Button
              variant="ghost"
              size="sm"
              onClick={onRefreshWhatsApp}
              title="Atualizar status"
            >
              Atualizar
            </Button>
          }
        />

        <Card.Body>
          {isConnected ? (
            <div className="flex flex-col justify-between gap-4 rounded-xl border border-surface-border bg-surface-subtle p-4 sm:flex-row sm:items-center">
              <div className="flex items-center gap-3.5">
                {whatsappStatus?.profile_picture_url ? (
                  <img
                    src={whatsappStatus.profile_picture_url}
                    alt="Avatar WhatsApp"
                    className="shadow-xs h-12 w-12 rounded-full border border-surface-border object-cover"
                  />
                ) : (
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-500/10 text-xs font-bold text-brand-600 dark:text-brand-400">
                    WA
                  </div>
                )}
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-content-main">
                      {whatsappStatus?.phone_number ||
                        whatsappStatus?.profile_name ||
                        'WhatsApp Conectado'}
                    </span>
                    <Badge variant="online" withDot pulse>
                      Conectado
                    </Badge>
                  </div>
                  {whatsappStatus?.profile_name &&
                    whatsappStatus?.phone_number && (
                      <p className="mt-0.5 text-xs text-content-muted">
                        Nome: {whatsappStatus.profile_name}
                      </p>
                    )}
                  <p className="mt-0.5 font-mono text-micro text-content-muted opacity-80">
                    Instância: {whatsappStatus?.instance_name}
                  </p>
                </div>
              </div>

              <Button variant="danger" size="sm" onClick={onDisconnectWhatsApp}>
                Desconectar Linha
              </Button>
            </div>
          ) : (
            <div className="flex flex-col justify-between gap-4 rounded-xl border border-surface-border bg-surface-subtle p-4 sm:flex-row sm:items-center">
              <div>
                <h4 className="text-xs font-semibold text-content-main">
                  Nenhum aparelho conectado
                </h4>
                <p className="mt-0.5 text-xs text-content-muted">
                  Conecte seu WhatsApp com leitura óptica para ativar os
                  disparos automáticos.
                </p>
              </div>

              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  if (onNavigateToWhatsApp) {
                    onNavigateToWhatsApp();
                  } else {
                    window.history.pushState(null, '', '/whatsapp');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                  }
                }}
              >
                Conectar com QR Code
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Outras Integrações / IA */}
      <Card>
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Inteligência Artificial (Gemini)
              </h3>
              <p className="text-xs text-content-muted">
                Configuração de chaves e parâmetros para extração de metadados e
                cópias de ofertas
              </p>
            </div>
          }
          action={<Badge variant="neutral">Em breve</Badge>}
        />
        <Card.Body>
          <p className="text-xs leading-relaxed text-content-muted">
            Motor de IA integrado diretamente nas rotinas de processamento de
            ofertas e extração de catálogo.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};
